module.exports = {
  init: function () {
    const treeHouses = $('.js-carousel-tree-houses');

    if (treeHouses.length > 0) {
      treeHouses.slick({
        lazyLoad: "ondemand",
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        centered: true,
        autoplay: true,
        autoplaySpeed: 3000,
        appendArrows: $('.js-arrows-container'),
        appendDots: $('.js-slick-slider-dots'),
      });
    }

  }
}
